module.exports = __webpack_public_path__ + "static/media/csm-provider.71f69767.svg";